@switch (columnName) {
  @case ('status') {
    <!-- <div
      [ngStyle]="{
        'background-color': getCertStatusColor(element[columnName])
      }"
    class="status"
  ></div> -->
    <!-- TODO remove if ui-pills works with new back-end STATUS property -->
    <app-ui-pill name="{{ element.status ? (element.status | lowercase) : 'ok' }}"></app-ui-pill>
  }
  @case ('action') {
    <mat-icon>recycling</mat-icon>
  }
  @case ('type') {
    {{ element.certificateType | translate }}
  }
  @case ('expand') {
    @if (element.count > 0) {
      <span [@rotatedState]="!expanded" (click)="toggle()">
        <mat-icon>expand_more</mat-icon>
      </span>
    }
  }
  @case ('issueDate') {
    @if (element.issueDate) {
      {{ element.issueDate | date }}
    }
  }
  @case ('expiryDate') {
    @if (element.expirationDate !== null) {
      {{ element.expirationDate | date }}
    } @else {
      {{ 'notProvided' | translate }}
    }
  }
  @case ('nextRevisionDate') {
    @if (element.nextRevisionDate !== null && element.nextRevisionDate !== undefined) {
      {{ element.nextRevisionDate | date }}
    } @else {
      {{ 'notProvided' | translate }}
    }
  }
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions ?? []; track $index) {
      <div>
        {{ position?.name }}
      </div>
    }
    @for (positionGroup of element.responsibleForPositionGroups ?? []; track $index) {
      <div>
        {{ positionGroup?.name }}
      </div>
    }
    @for (role of element.responsibleForRoles ?? []; track $index) {
      <div>
        {{ role?.name }}
      </div>
    }
  }
  @case ('renew') {
    @if (element.expirationDate || element.nextRevisionDate) {
      <app-ui-button
        buttonType="icon-button"
        class="renew-button"
        icon="recycling"
        [routerLink]="routerLink + element.id"
      ></app-ui-button>
    }
  }
  @case ('restore') {
    <app-ui-button
      appConfirmDialog
      appStopClickPropagation
      confirmTitle="restore"
      confirmMessage="youAreRestoring"
      [confirmEntityName]="element.name"
      (confirmed)="restore()"
      buttonType="secondary"
      text="{{ 'restore' | translate }}"
      [privilege]="Privileges.CertificateRestore"
    ></app-ui-button>
  }
  @default {
    {{ element[columnName] }}
  }
}
